import { useTranslate } from "@similarweb/i18n-provider";
import { Info24px } from "@similarweb/icons";
import type { ActivationAlertsContractAdPublisher } from "@similarweb/pro-api-client";
import { colorsPalettes } from "@similarweb/styles";
import { ItemIcon, Tooltip, Type } from "@similarweb/ui-components";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";
import { styled } from "styled-components";

import { getFaviconUrl } from "app/services/sitesService/sitesUtils";

const SmallItemIcon = styled(ItemIcon)`
    width: 24px;
    height: 24px;
`;

interface IPublishersSectionProps {
    publishers: ActivationAlertsContractAdPublisher[];
}

export const PublishersSection = ({ publishers }: IPublishersSectionProps) => {
    const { translate } = useTranslate();

    if (!publishers.length) {
        return null;
    }

    return (
        <Stack
            gap="16px"
            data-automation="ads-alert-modal-publishers-section"
        >
            <Flex
                gap="8px"
                alignItems="center"
            >
                <Text
                    fontVariant="h5_2"
                    color={colorsPalettes.carbon[500]}
                >
                    {translate("activation.alerts.cards.display-ads.modal.top-publishers")}
                </Text>
                <Tooltip content={translate("activation.alerts.cards.display-ads.modal.top-publishers.tooltip")}>
                    <Info24px
                        size="sm"
                        color={colorsPalettes.carbon[300]}
                    />
                </Tooltip>
            </Flex>
            <Stack gap="8px">
                {publishers.map((publisher) => (
                    <Flex
                        key={publisher.domain}
                        alignItems="center"
                        gap="8px"
                    >
                        <SmallItemIcon
                            iconType={Type.Website}
                            iconSrc={getFaviconUrl(publisher.domain)}
                        />
                        <Text
                            as="a"
                            href={`https://${publisher.domain}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            fontVariant="input2"
                            color={colorsPalettes.blue[400]}
                        >
                            {publisher.domain}
                        </Text>
                    </Flex>
                ))}
            </Stack>
        </Stack>
    );
};
